import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { MUIButton, Autocomplete } from 'app/components/Form';
import ModalTrigger from 'app/components/Modal/ModalTrigger.jsx';
import ModalEditDashboard from 'app/pages/Project/Settings/Dashboards/ModalEditDashboard/ModalEditDashboard';
import classes from 'app/pages/Project/Settings/Dashboards/Toolbar/styles.module.scss';
const DashboardsSettingsToolbar = ({ projectId, dashboardId, dashboards }) => {
    const history = useHistory();
    const options = dashboards.map((dashboard) => ({ label: dashboard.name, value: dashboard.id }));
    const onSelectDashboard = ({ value: dashboardId }) => {
        history.push(`/projects/${projectId}/settings/dashboards/${dashboardId}`);
    };
    return (_jsxs("div", { className: classes.container, children: [_jsx(ModalTrigger, { modal: _jsx(ModalEditDashboard, { projectId: projectId }), children: _jsx(MUIButton, { color: "primary", children: "Create new dashboard" }) }), _jsx("div", { children: _jsx(Autocomplete, { options: options, placeholder: "Search an existing dashboard", selected: dashboardId, onChange: onSelectDashboard, searchable: true, style: { minWidth: '270px' } }) })] }));
};
export default DashboardsSettingsToolbar;
